'use client';

import { EXPCONFIG_FAST } from '@/constants/point';
import { getI18nLang } from '@/i18n/settings';
import { useStores } from '@/models';
import { observer } from 'mobx-react-lite';
import { useMemo, useState } from 'react';

import { EXPOSURE_RECORD, sendClickTrack } from '@/tracks/25061';

import LanguageDropdown from '../LanguageDropdown';

import { LANGUAGE_CONFIG } from '@/constants/languageConfig';

import ArrowDown from '@/assets/icons/arrow-down.svg';
import { Skeleton } from '@mui/material';
import CDNImage from '@/components/cdnImage/cdnImage';

// import '@/components/header/header.css';
import styles from './index.module.scss';

export const LanguageLogoClient = observer(() => {
  const { countryStore } = useStores();
  const [flagLoading, setFlagLoading] = useState<boolean>(true);

  const langConfig = useMemo(() => {
    const langCode = countryStore.currentLanguageCode || getI18nLang();
    return LANGUAGE_CONFIG.find((lang) => lang.languageCode?.includes(langCode));
  }, [countryStore.currentLanguageCode]);

  const handleGoChange = () => {
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.delete('returnUrl');
    const returnUrl = encodeURIComponent(currentUrl.toString());
    window.location.href = `/settings/customise?returnUrl=${returnUrl}`;
  };

  return (
    <div className={styles.countryWrap} onClick={handleGoChange}>
      <button
        className={styles.countryCurrent}
        exptag={'exp|' + EXPOSURE_RECORD.Header_Country_Expo}
        data-exptag-config={EXPCONFIG_FAST}
        onClick={sendClickTrack.Header_Country}
      >
        <div className={styles.flagContainer}>
          {countryStore.currentCountryData?.flagImage && (
            <>
              <Skeleton
                variant='rectangular'
                animation='wave'
                className={!flagLoading ? styles.hidden : styles.flagSkeleton}
                width={20}
                height={14}
              />
              <CDNImage
                src={countryStore.currentCountryData.flagImage}
                alt={countryStore.currentCountryData.name}
                width={20}
                height={14}
                className={`${styles.countryFlag} ${flagLoading ? styles.hidden : ''}`}
                onLoad={() => setFlagLoading(false)}
                onError={() => setFlagLoading(false)}
              />
            </>
          )}
        </div>
        <span>{langConfig?.displayName || ''}</span>
        <ArrowDown className={styles.arrowDown} />
      </button>
      <div className={styles.countryListDropdownLayer}>
        {LANGUAGE_CONFIG && <LanguageDropdown handleGoChange={handleGoChange} />}
      </div>
    </div>
  );
});
